import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import { QuestionType } from '@module/form';
/**
 * Result of a question type switch operation
 * Contains metadata about what should be preserved/reset during the switch
 */

/**
 * Base abstract class with common helper methods
 */
export var BaseQuestionSwitchStrategy = /*#__PURE__*/function () {
  function BaseQuestionSwitchStrategy(fromType) {
    _classCallCheck(this, BaseQuestionSwitchStrategy);

    this.fromType = fromType;
  }

  _createClass(BaseQuestionSwitchStrategy, [{
    key: "isToEssay",
    value:
    /** Helper: Check if switching to Essay */
    function isToEssay(toType) {
      return toType === QuestionType.Essay;
    }
    /** Helper: Check if switching to choice type (Single/Multiple) */

  }, {
    key: "isToChoiceType",
    value: function isToChoiceType(toType) {
      return toType === QuestionType.SingleChoice || toType === QuestionType.MultipleChoice;
    }
    /** Helper: Check if switching to complex type (Fill/Matching) */

  }, {
    key: "isToComplexType",
    value: function isToComplexType(toType) {
      return toType === QuestionType.FillInBlank || toType === QuestionType.Matching;
    }
  }]);

  return BaseQuestionSwitchStrategy;
}();